const styles: Record<string, string> = {
  ACTIVE: 'bg-success/15 text-success',
  PAUSED: 'bg-warning/15 text-warning',
  ARCHIVED: 'bg-text-muted/15 text-text-muted',
  DELETED: 'bg-text-muted/15 text-text-muted',
  CAMPAIGN_PAUSED: 'bg-warning/15 text-warning',
  IN_PROCESS: 'bg-info/15 text-info',
  WITH_ISSUES: 'bg-danger/15 text-danger',
  PENDING_REVIEW: 'bg-info/15 text-info',
  DISAPPROVED: 'bg-danger/15 text-danger',
  PREAPPROVED: 'bg-info/15 text-info',
  PENDING_BILLING_INFO: 'bg-warning/15 text-warning',
  ADSET_PAUSED: 'bg-warning/15 text-warning',
  AD_PAUSED: 'bg-warning/15 text-warning',
};

export const CampaignStatusPill: React.FC<{ status: string }> = ({ status }) => (
  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${styles[status] ?? 'bg-surface-alt text-text-muted'}`}>
    {(status ?? 'UNKNOWN').replace(/_/g, ' ')}
  </span>
);
